import { render, staticRenderFns } from "./DeliveryDetailsBlock.vue?vue&type=template&id=b8d510c0&lang=pug&"
import script from "./DeliveryDetailsBlock.vue?vue&type=script&lang=js&"
export * from "./DeliveryDetailsBlock.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryDetailsBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VDivider,VIcon})
